export default __webpack_public_path__ + "static/media/danyyil_zakharchuk.9b299d0a.jpg";